import React, { useState, useEffect, useContext, useMemo } from "react";
import "./team.scss";
import axios from "axios";
import { useParams } from "react-router";
import Breadcrumbs from "../../common/breadcumb";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";

function BranchManager() {
  const lang = useContext(LangContext);
  const nep = lang.state.np;
  const { slug: rawSlug } = useParams();
  const [content, setContent] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // Resolve slug and title once on mount or when rawSlug/nep changes
  const slug = useMemo(() => {
    if (rawSlug === "branch-managers") {
      setPageTitle(nep ? " शाखा प्रबन्धकहरू" : "Branch Managers");
      return "branch-manager";
    } else if (rawSlug === "extension-incharge") {
      setPageTitle(
        nep ? "विस्तारित काउन्टर इन्चार्ज" : "Extension Counter Incharge",
      );
      return "extension-incharge";
    } else {
      setPageTitle(
        nep ? "अपाङ्गमैत्री शाखा" : "Differently Abled Friendly Branch",
      );
      return "disabled-friendly-branch";
    }
    // Default case

    setPageTitle("Branch Manager");
    return rawSlug;
  }, [rawSlug, nep]);

  const APIURL = `${process.env.REACT_APP_URL}team/all/${slug}`;
  // console.log("UR", APIURL);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setContent(response.data.items);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [APIURL]);

  const MainData = useMemo(() => {
    if (!content) return [];
    return nep ? content.np : content.en;
  }, [content, nep]);

  if (loading) return <Loading />;
  if (error) return <Errors />;
  // console.log(MainData);
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="InsidePageContainer">
        <div className="wrapper">
          {rawSlug === "disabled-friendly-branch" ? (
            <div className="BranchManagerContainer">
              <div className="BranchManager">
                <h2>Taulihawa Branch</h2>
                <p>Branch Manager : Pankaj Kumar Tripathi</p>
                <p>Kapilvastu-1,Taulihawa</p>
                <p>Mobile : 9847277726</p>
                <p>Tel : 076-561112/076-561113</p>
                <p>Email : pankaj.tripathi@gmbf.com.np</p>
              </div>
              <div className="BranchManager">
                <h2>Narayangarh Branch</h2>
                <p>Branch Manager : Hari Prasad Adhikari</p>
                <p>Sahidchowk, Narayangarh</p>
                <p>Mobile : 9857040982</p>
                <p>Tel : 056-596913/056-596813</p>
                <p>Email : hariprasad.adhikari@gmbf.com.np</p>
              </div>
            </div>
          ) : (
            <div className="BranchManagerContainer">
              {MainData.length === 0
                ? "No Team Found."
                : MainData.map((team) => (
                    <div key={team.id} className="BranchManager">
                      <h2>{team?.name}</h2>
                      <p>
                        {/* <b>{nep ? "शाखा" : "Branch"} : </b> */}
                        {team?.branch}
                      </p>
                      <p>{team?.address}</p>
                      <p>{team?.contact}</p>
                      <p>{team?.email}</p>
                    </div>
                  ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default BranchManager;
